export const keyZipObject = keyList => {
    const result = {};
    keyList.forEach(v => (result[v] = v));
    return result;
};